module.exports = __webpack_public_path__ + "static/media/bduwisom.5222e92c.jpg";